
export default {
  name: 'PartAll',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataMap: ['总体满意度得分、维度得分', '细节指标得分', '单个顾客、员工态度'],
      image: [require('~/assets/image/scence/satisfaction/part-all.png')],
    }
  },
}
